import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
const CommanPhoneNumber = ({ value, handleMobileNumber }: any) => {

    const handlePhone = (value: any, code: any) => {
        const regex = new RegExp(code?.dialCode)
        const phone = value.replace(regex, "");
        handleMobileNumber(value, code, phone)
    }
    return (
        <>
            <PhoneInput
                inputClass="f-input w-100"
                placeholder=""
                disableInitialCountryGuess={false}
                enableLongNumbers={false}
                country={"us"}
                countryCodeEditable={false}
                value={value}
                // value={`${('phone_country_code')}${('phone_number')}`}
                onChange={handlePhone}
            />
        </>
    )
}

export default CommanPhoneNumber;
